import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import AuthLoader from '../../components/AuthLoader'
import AuthLoaderError from '../../components/AuthLoader/AuthLoaderError'
import qs from 'qs'
import jwt_decode from 'jwt-decode'
import '../../containers/Simulation/simulation.css'

import {
  isTokenValid,
  tokenLogin,
  loginUserAndCleanUrl,
  logout,
  loginUserSuccess
} from '../../store/actions/auth'

const actionCreators = {
  loginUserAndCleanUrl,
  logout,
  loginUserSuccess
}

function mapStateToProps(state) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    token: state.auth.token
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch)
}

export default function (ComposedComponent, allowedUserTypes, allowTokenLogin = false) {
  class Authentication extends Component {
    constructor(props) {
      super(props)
      this.state = {
        isValidToken: false,
        error: null
      }
    }

    componentDidMount() {
      if (allowTokenLogin) {
        let queryString = this.props.location.search
          ? this.props.location.search.split('?')[1]
          : null
        let queryObject = qs.parse(queryString)
        let newToken = queryObject.token
        if (newToken && !this.props.isAuthenticated) {
          tokenLogin(newToken)
            .then((response) => {
              if (response.token) {
                this.setState({
                  isValidToken: true,
                  error: null
                })
                this.checkAllowedTypes(response.token)
                this.props.loginUserAndCleanUrl(response.token)
              } else {
                this.props.logout()
              }
            }).catch(error => {
              const message = error.response ? error.response.data.message : 'Error al comunicarse con el servidor. Favor reintente más tarde.'
              this.setState({
                error: message
              })
            })
        } else {
          this.checkAuth()
        }
      } else {
        this.checkAuth()
      }
    }

    checkAllowedTypes = (token) => {
      const decodedToken = jwt_decode(token)
      const userType = decodedToken.type
      if (!allowedUserTypes.includes(userType)) {
        this.goToRoute('/not-found')
      }
    }

    goToRoute = (route) => {
      this.props.history.push(route)
    }

    replaceRoute = (route) => {
      this.props.history.replace(route)
    }

    checkAuth(props = this.props) {
      const token = localStorage.getItem('token')
      if (!props.isAuthenticated) {
        if (!token) {
          props.logout()
          if (!allowTokenLogin) {
            this.goToRoute('/login')
          } else {
            this.setState({
              error: 'No está autorizado para ver esta página. Por favor ingrese a través de su Sucursal Virtual'
            })
          }
        } else {
          isTokenValid(token)
            .then((response) => {
              if (response.isValid) {
                this.setState({ isValidToken: true, error: null })
                this.checkAllowedTypes(token)
                this.props.loginUserSuccess(token)
              }
            }).catch((error) => {
              props.logout()
              const message = error.response ? error.response.data.message : 'Error al comunicarse con el servidor. Favor reintente más tarde.'
              this.setState({
                error: message
              })
            })
        }
      } else {
        this.setState({
          isValidToken: true,
          error: null
        })
      }
    }

    render() {
      if (this.state.error) {
        return <AuthLoaderError error={this.state.error} />
      }
      return (
        <React.Fragment>
          {this.props.isAuthenticated && this.state.isValidToken
            ? <ComposedComponent {...this.props} />
            : <AuthLoader />
          }
        </React.Fragment>
      )
    }
  }
  return connect(mapStateToProps, mapDispatchToProps)(Authentication)
}
